import { createActions, handleActions } from 'redux-actions';

import * as loadingState from '@coconut/constants/loadingState';

export const types = {
  REJECT_TUTOR: 'REJECT_TUTOR',
  REJECT_TUTOR_SUCCESS: 'REJECT_TUTOR_SUCCESS',
  REJECT_TUTOR_FAILED: 'REJECT_TUTOR_FAILED',
};

export const { rejectTutor, rejectTutorSuccess, rejectTutorFailed } =
  createActions(
    {
      [types.REJECT_TUTOR]: (userID, QID) => ({
        userID,
        QID,
      }),
    },
    types.REJECT_TUTOR_SUCCESS,
    types.REJECT_TUTOR_FAILED
  );

const INIT_STATE = {
  errorMessage: '',
  loadingStatus: loadingState.EMPTY,
};

const reducer = handleActions(
  {
    [types.REJECT_TUTOR]: (state) => ({
      ...state,
      loadingStatus: loadingState.LOADING,
    }),
    [types.REJECT_TUTOR_SUCCESS]: (state) => ({
      ...state,
      loadingStatus: loadingState.READY,
      errorMessage: '',
    }),
    [types.REJECT_TUTOR_FAILED]: (state, action) => ({
      ...state,
      loadingStatus: loadingState.READY,
      errorMessage: action.payload.errorMessage,
    }),
  },
  INIT_STATE
);

export default reducer;



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/redux/rejectTutor.js